var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 11.5,
    viewBox: "0 0 11.5 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wallet-3814518",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122257",
    "data-name": "Path 122257",
    d: "M5.155,1.546h7.424V.154A.155.155,0,0,0,12.4,0L5.129,1.239A.155.155,0,0,0,5,1.392v.183A.459.459,0,0,1,5.155,1.546Z",
    transform: "translate(-4.231 0)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122258",
    "data-name": "Path 122258",
    d: "M12.722,13.937h2.39V12.194A.189.189,0,0,0,14.928,12H5.184A.189.189,0,0,0,5,12.194v5.192a2.471,2.471,0,0,1,2.586,0,2.753,2.753,0,0,1,1.29,2.362c0,.065,0,.129-.009.194h6.062a.189.189,0,0,0,.184-.194V17.812h-2.39a.567.567,0,0,1-.552-.581V14.518A.567.567,0,0,1,12.722,13.937Z",
    transform: "translate(-4.231 -10.144)",
    fill: "#5142fc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 0.257,
    rx: 0.257,
    transform: "translate(9.893 5.75)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122259",
    "data-name": "Path 122259",
    d: "M48.629,24H46.155a.155.155,0,0,0-.155.155V26.32a.155.155,0,0,0,.155.155h2.475a.155.155,0,0,0,.155-.155V24.155A.155.155,0,0,0,48.629,24Zm-1.237,1.7a.464.464,0,1,1,.464-.464A.464.464,0,0,1,47.392,25.7Z",
    transform: "translate(-37.284 -19.487)",
    fill: "#dcf8c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122260",
    "data-name": "Path 122260",
    d: "M2.653,42.034H2.034v.619a.155.155,0,0,1-.309,0v-.619H1.106a.155.155,0,1,1,0-.309h.619v-.619a.155.155,0,0,1,.309,0v.619h.619a.155.155,0,1,1,0,.309Zm-.771-2.006a1.854,1.854,0,1,0,1.854,1.854A1.854,1.854,0,0,0,1.882,40.028Z",
    transform: "translate(-0.028 -32.236)",
    fill: "#dcf8c5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendDeposit);
export default __webpack_public_path__ + "static/media/friend-deposit.44db2fda0a97f5f6e7673499731cdc5a.svg";
export { ForwardRef as ReactComponent };